/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMerchantForPlatformAccountRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {GetMerchantResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const getMerchantForPlatformAccount = (request: GetMerchantForPlatformAccountRequest, options?: CashRequestOptions) => post<GetMerchantForPlatformAccountRequest, GetMerchantResponse>("/2.0/cash/get-merchant-for-platform-account", request, {...options, rejectOnError: true })